import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// components
import TooltipWithMessage from "core/TooltipWithMessage";

const EditorialUseOnly = () => {
    const { state } = useContext(AssetDownloadContext);
    const {
        asset: { editorialUseOnly }
    } = state;

    if (!editorialUseOnly) {
        return null;
    }

    return (
        <TooltipWithMessage
            text="Editorial Use Only"
            toolTipText="Can only be used to illustrate matters of public interest. Can't
            be used to advertise a product or service."
        />
    );
};

export default EditorialUseOnly;
